/*eslint-disable*/

import React, {
	ReactNode,
	useContext,
	useEffect,
	useRef,
	useState,
} from "react";
import "../../components/DoctaChatBox/index.css";
import { Collapse, Modal, Spin, Typography, Card, Button, message } from "antd";
import type { CollapseProps } from "antd";
import {
	PlusCircleOutlined,
	MinusCircleFilled,
	FullscreenExitOutlined,
	FullscreenOutlined,
	ShareAltOutlined,
	CopyOutlined,
} from "@ant-design/icons";
import "./index.css";
import AvatarUser from "../../../static/icon/AvatarUser.svg";
import { Image } from "react-bootstrap";
import MyContext from "../Mycontext";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../providers/CustomThemeProvider";
import { SendQAFeedback } from "../../../api/Api";

import contentPaste from "../../../static/icon/content_paste.svg";
import lightContentPaste from "../../../static/light-icon/content_paste.svg";
import thumbup from "../../../static/icon/thumbs_up_icon.svg";
import lightThumbup from "../../../static/light-icon/thumbs_up_icon.svg";
import thumbdown from "../../../static/icon/thumbs_down_icon.svg";
import lightThumbdown from "../../../static/light-icon/thumbs_down_icon.svg";
import filledThumbup from "../../../static/icon/filled_thumbs_up_icon.svg";
import filledLightThumbup from "../../../static/light-icon/filled_thumbs_up_icon.svg";
import filledThumbdown from "../../../static/icon/filled_down_thumbs_icon.svg";
import filledLighthumbdown from "../../../static/light-icon/filled_down_thumbs_icon.svg";
import toast from "react-hot-toast";
import MoreDataBtn from "../MoreDataBtn";
import { copyConter, QAStatus } from "../NormalDoctaChatBox";

interface IProps {
	type: string | number;
	refreshCallback: () => void;
	scrollBoxRef?: any;
	isStream?: boolean;
	data?: any;
	showThumb?: boolean;
}

export const checkIsJSON = (str: string | object): boolean => {
	if (typeof str == "string") {
		try {
			const obj = JSON.parse(str);
			if (typeof obj == "object" && obj) {
				return true;
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}
	return false;
};

const StreamingDoctaChatBox = (props: IProps) => {
	const {
		refreshCallback,
		scrollBoxRef,
		isStream = true,
		data,
		showThumb = false,
	} = props;
	const [qdDisplay, setQdDisplay] = useState<CollapseProps["items"]>([]);
	const [tmpQdData, setTmpQdData] = useState<any>([]);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [stringData, setStringData] = useState<string>("");
	const [combinedMessage, setCombinedMessage] = useState<string>("");
	const [subfixMessage, setSubfixMessage] = useState<string>("");
	const { t, i18n } = useTranslation();
	const [typingCnt, setTypingCnt] = useState<number>(0);
	const [stData, setStData] = useState<any>(null);
	const [st, setSt] = useState<any>(null);
	// QA反馈
	const [qaStatus, setQaStatus] = useState<string>("");
	const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
	const [isFullScreenIdx, setIsFullScreenIdx] = useState<number>(-1);
	const [fullScreenItem, setFullScreenItem] = useState<any>(null);
	const scrollContainerRef = useRef<HTMLDivElement>(null);
	const [isAtEnd, setIsAtEnd] = useState(false);

	const toggleFullScreen = (index: any) => {
		setIsFullScreenIdx(index);
		setIsFullScreen(!isFullScreen);
	};

	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const {
		selectedChat,
		requireType,
		current,
		save,
		setCurrent,
		setNeedFresh,
		listen,
		setListen,
	} = context;
	const { isDarkMode } = useTheme();
	const panelStyle: React.CSSProperties = {
		marginBottom: 10,
		background: isDarkMode
			? "rgba(246, 246, 246, 0.29)"
			: "rgba(246, 246, 246, 0.7)",

		borderRadius: 15,
		border: "none",
	};

	const pushData = (
		qdData: any,
		item: any,
		indexOuter: number,
		displayList: CollapseProps["items"]
	) => {
		const system = qdData[item]?.system;
		const instruction = qdData[item]?.instruction;
		const response = qdData[item]?.response;

		displayList?.push({
			key: indexOuter,
			label: item,
			style: panelStyle,
			children: (
				<div className="dataset-wrapper">
					{system && system}
					<div className="qa-response-title">数据 {indexOuter + 1}</div>
					<div className="response-wrapper hidden-scrollbar">
						{instruction?.map((item: string, index: number) => {
							return (
								<div className="qa-response" key={index}>
									<div className="qa-response-content">
										<div className="qa-response-content-left">Instruction:</div>
										<div className="qa-response-content-right">
											{item?.replace("Instruction:", "")}
										</div>
										{/* </div>

								<div className="qa-response-content"> */}
										<div className="qa-response-content-left">Response:</div>
										<div className="qa-response-content-right">
											{response?.[index]?.replace("Response:", "")}
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			),
		});
	};

	useEffect(() => {
		let latestMessage = current?.[current?.length - 1];

		if (checkIsJSON(latestMessage)) {
			latestMessage = JSON.parse(latestMessage);

			// parse Query data
			let qdData = latestMessage as any;

			if (qdData?.data) {
				qdData = qdData?.data;
			} else if (qdData?.[0]) {
				qdData = JSON.parse(qdData?.[0]);
			}

			console.log("qdDataqdDataqdDataqdDataqdData", qdData);

			if (typeof qdData?.single_message == "string") {
				// setMessage(qdData?.single_message);
				setStringData(qdData?.single_message);

				return;
			}
			if (qdData?.error) {
				message.error(qdData?.error?.toString());
			}

			if (qdData?.prefix_data_message && qdData?.prefix_data_message != "") {
				requireType != "img" && setCombinedMessage(qdData?.prefix_data_message);
			}

			if (qdData?.subfix_data_message && qdData?.subfix_data_message != "") {
				requireType != "img" && setSubfixMessage(qdData?.subfix_data_message);
			}

			setStringData("");
			if (qdData?.img_list?.length > 0) {
				refreshCallback();
				return;
			}

			if (qdData && typeof qdData === "object" && !Array.isArray(qdData)) {
				const displayList: CollapseProps["items"] = [];
				let cnt = 0;

				Object.keys(qdData).map((item, index) => {
					if (
						!(
							process.env.REACT_APP_ENV === "production" &&
							item.startsWith("ChatGPT returns")
						)
					) {
						if (
							item != "prefix_data_message" &&
							item != "subfix_data_message" &&
							item != "error"
						) {
							if (typeof qdData[item] === "object") {
								pushData(qdData, item, cnt, displayList);
								cnt += 1;
							} else {
								displayList.push({
									key: cnt,
									label: item,
									children: qdData[item],
									style: panelStyle,
								});
							}
						}
					}
				});
				!isStream && setQdDisplay(displayList as any);
				requireType != "img" && isStream && setTmpQdData(displayList as any);
			}
		} else {
			setStringData(current);
		}

		setListen(!listen);
	}, [current]);

	useEffect(() => {
		if (tmpQdData?.length > 0) {
			let ind = currentIndex;

			const interval = setInterval(() => {
				if (ind < tmpQdData.length) {
					const current = {
						...tmpQdData?.[ind],
						style: {
							...tmpQdData?.[ind].style,
							opacity: 0,
							animation: "fadeIn 1s ease-in-out forwards",
						},
					};

					requireType != "img" &&
						isStream &&
						setQdDisplay((prev: any) => [...prev, current]);
				} else {
					if (save) {
						// refreshCallback();
						// setQdDisplay([]);
						// setTmpQdData([]);
						ind = 0;
					}
					clearInterval(interval);
				}
				ind++;

				setCurrentIndex((prevIndex: any) => {
					return prevIndex + 1;
				});
			}, 500);
			return () => clearInterval(interval);
		}
	}, [tmpQdData]);

	const sendFeedback = async (likeDislike: number) => {
		/* eslint-disable  @typescript-eslint/no-explicit-any */
		const context = {} as any;
		stData?.map((item: any) => {
			context[item.name] = item.data;
		});
		const params = {
			likeDislike: likeDislike,
			context: context,
		};

		await SendQAFeedback(params);
	};

	// useEffect(() => {
	// 	if (save && stringData != "") {
	// 		refreshCallback();
	// 		setQdDisplay([]);
	// 		setTmpQdData([]);
	// 		setStringData("");
	// 		setCombinedMessage("");
	// 		setSubfixMessage("");
	// 	}
	// }, [stringData, save]);

	const handleCancel = () => {
		setIsFullScreen(false);
	};

	return (
		<>
			<Modal
				open={isFullScreen}
				// onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
				width={"100vw"}
				className={"fullscreen-card"}
				// bodyStyle={{ height: "calc(100vh-70px-53px)" }}
				bodyProps={{ height: "100vh" }}
			>
				<Card
					style={{
						overflowY: "scroll",
						width: "100%",
					}}
					// @ts-ignore
					variant="borderless"
					className={`hidden-scrollbar data-card-full`}
				>
					<>{fullScreenItem && fullScreenItem.children} </>
				</Card>
			</Modal>
			<div className="streaming">
				{requireType != "img" && (
					<div
						className={"chatList-item"}
						key={`${selectedChat?.messages?.length ?? 1}`}
						id={`${selectedChat?.messages?.length ?? 1}`}
					>
						{/* <div className="chatList-item-img">
							<Image src={AvatarUser} />
						</div> */}
						<div className="chatList-item-user">
							{/* <div className="chatList-item-user-name">
								{i18n.language == "en" ? "DOCTA" : "第五维度"}
							</div> */}
							<div className="chatList-item-box-wrapper">
								<div className="chatList-item-dialog-box-ai">
									<div className="qdData-color">
										{stringData != "" ? (
											stringData
										) : (
											<>
												<p className="qdData-color-title">
													<Typography>
														<blockquote>
															{combinedMessage != "" && combinedMessage}
														</blockquote>
													</Typography>
												</p>
												{qdDisplay?.length == 0 && (
													<Spin tip="Loading..." style={{ width: "100%" }} />
												)}
												<div className="data-card-wrapper">
													{/* <div
														className={`scroll-container ${
															!isAtEnd ? "with-gradient" : ""
														}`}
													> */}
													<div className={"scroll-container"}>
														<div
															className="scroll-content"
															ref={scrollContainerRef}
														>
															{/* <div
													style={{
														display: "flex",
														flexDirection: "row",
														overflowX: "scroll",
														gap: "10px",
													}}
													className="hidden-scrollbar data-card-wrapper"
												> */}
															{tmpQdData?.map((item: any, index: number) => {
																return (
																	<div className="single-card-wrapper">
																		<Card
																			// @ts-ignore
																			variant="borderless"
																			className={`hidden-scrollbar data-card`}
																		>
																			{isStream ? (
																				<TypingEffect
																					children={item.children}
																					cnt={tmpQdData.length}
																					refreshCallback={refreshCallback}
																					typingCnt={typingCnt}
																					setTypingCnt={setTypingCnt}
																					save={save}
																					setCurrent={setCurrent}
																					setNeedFresh={setNeedFresh}
																				/>
																			) : (
																				<>{item.children} </>
																			)}
																		</Card>
																		<div className="single-card-wrapper-footer">
																			{/* <div className="footer-left">
																				<Button type="text" onClick={() => {}}>
																					<ShareAltOutlined />
																				</Button>
																				<Button type="text" onClick={() => {}}>
																					<CopyOutlined />
																				</Button>
																			</div> */}
																			<div className="footer-right">
																				<Button
																					type="text"
																					onClick={() => {
																						toggleFullScreen(index);
																						setFullScreenItem(item);
																					}}
																				>
																					{isFullScreen ? (
																						<FullscreenExitOutlined />
																					) : (
																						<FullscreenOutlined />
																					)}
																				</Button>
																			</div>
																		</div>
																	</div>
																);
															})}
														</div>
													</div>
												</div>
												<Typography>
													<blockquote>
														{subfixMessage != "" ? subfixMessage : <></>}
													</blockquote>
												</Typography>
											</>
										)}
									</div>

									<div className="box-footer">
										{st?.return_type != "single_message" && (
											<MoreDataBtn data={st} />
										)}
										{showThumb && (
											<>
												<Image
													src={
														isDarkMode
															? qaStatus === QAStatus.GOOD
																? filledThumbup
																: thumbup
															: qaStatus === QAStatus.GOOD
															? filledLightThumbup
															: lightThumbup
													}
													className="thumbup-btn"
													onClick={() => {
														setQaStatus(QAStatus.GOOD);
														sendFeedback(1);
													}}
												/>
												<Image
													src={
														isDarkMode
															? qaStatus === QAStatus.BAD
																? filledThumbdown
																: thumbdown
															: qaStatus === QAStatus.BAD
															? filledLighthumbdown
															: lightThumbdown
													}
													className="thumbdown-btn"
													onClick={() => {
														setQaStatus(QAStatus.BAD);
														sendFeedback(-1);
													}}
												/>
											</>
										)}
										<Image
											src={isDarkMode ? contentPaste : lightContentPaste}
											className="copy-btn"
											onClick={() => {
												// const obj = JSON.parse(stData)?.data;
												const obj = stData;

												const copyText = Object.keys(obj).reduce(
													(acc: any, key: any) => {
														if (key.startsWith("Data")) {
															acc[key] = obj[key];
														}
														return acc;
													},
													{}
												);

												copyConter(JSON.stringify(copyText));
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default StreamingDoctaChatBox;

// const TypingText = ({ key, text, onComplete, setTypingCnt }: any) => {
// 	const [displayedText, setDisplayedText] = useState("");
// 	const indexRef = useRef(0);

// 	useEffect(() => {
// 		setDisplayedText("");
// 		indexRef.current = -1;

// 		const interval = setInterval(() => {
// 			setDisplayedText((prev) => {
// 				indexRef.current += 1;

// 				console.log(indexRef.current, text.length, text);

// 				if (indexRef.current === text.length) {
// 					clearInterval(interval);
// 					setTypingCnt((prev: number) => prev + 1);
// 					onComplete(); // 通知 TypingEffect 当前文本已完成
// 				}

// 				return prev + (text[indexRef.current] ?? "");
// 			});
// 		}, 50); // 速度可以调节

// 		return () => clearInterval(interval);
// 	}, [text]);

// 	return <>{displayedText}</>;
// };

// const renderWithTypingEffect = (
// 	node: ReactNode,
// 	currentIndex1: number,
// 	onComplete: () => void,
// 	index: number,
// 	cnt?: number,
// 	typingCnt?: any,
// 	setTypingCnt?: any,
// 	save?: any,
// 	setNeedFresh?: any,
// 	setCurrentIndex1?: any,
// 	currentIndexRef?: React.MutableRefObject<number>
// ): any => {
// 	useEffect(() => {
// 		if (typingCnt === (cnt ?? 1) * 6 && save) {
// 			// refreshCallback && refreshCallback();
// 			setTypingCnt(0);
// 			// setCurrent([]);
// 			setNeedFresh(true);
// 		}
// 	}, [typingCnt]);

// 	if (typeof node === "string") {
// 		return index <= currentIndex1 ? (
// 			<TypingText
// 				key={index}
// 				text={node}
// 				onComplete={onComplete}
// 				setTypingCnt={setTypingCnt}
// 			/>
// 		) : null;
// 	}

// 	if (React.isValidElement(node)) {
// 		const children = React.Children.toArray(node.props.children);
// 		return React.cloneElement(
// 			node,
// 			{},
// 			children.map((child, index) => {
// 				const newIndex = setCurrentIndex1((prev: any) => prev + 1);
// 				return renderWithTypingEffect(
// 					child,
// 					currentIndex1,
// 					onComplete,
// 					newIndex,
// 					cnt,
// 					typingCnt,
// 					setTypingCnt,
// 					save,
// 					setNeedFresh,
// 					setCurrentIndex1,
// 					currentIndexRef
// 				);
// 			})
// 		);
// 	}
// 	return node;
// };

// const TypingEffect = ({
// 	children,
// 	cnt,
// 	typingCnt,
// 	setTypingCnt,
// 	save,
// 	setNeedFresh,
// }: any) => {
// 	const currentIndexRef = useRef(0);
// 	const elements = React.Children.toArray(children);

// 	const [currentIndex1, setCurrentIndex1] = useState(0);
// 	const handleComplete = () => {
// 		setCurrentIndex1((prev: any) => prev + 1); // 逐个解锁文本渲染
// 	};

// 	return (
// 		<>
// 			{elements.map((child, index) => {
// 				return renderWithTypingEffect(
// 					child,
// 					currentIndex1,
// 					handleComplete,
// 					index,
// 					cnt,
// 					typingCnt,
// 					setTypingCnt,
// 					save,
// 					setNeedFresh,
// 					setCurrentIndex1,
// 					currentIndexRef
// 				);
// 			})}
// 		</>
// 	);
// };

const TypingEffect = ({
	children,
	cnt,
	typingCnt,
	setTypingCnt,
	save,
	setNeedFresh,
	speed = 30,
}: any) => {
	const [displayedNodes, setDisplayedNodes] = useState<React.ReactNode[]>([]);
	const allTextNodes: string[] = [];
	const indexRef = useRef(0);

	useEffect(() => {
		if (typingCnt === cnt && save) {
			setTypingCnt(0);
			setNeedFresh(true);
		}
	}, [typingCnt]);

	// 递归提取所有文本节点
	const extractTextNodes = (node: React.ReactNode) => {
		if (typeof node === "string") {
			allTextNodes.push(...node.split(""));
		} else if (React.isValidElement(node) && node.props.children) {
			React.Children.forEach(node.props.children, extractTextNodes);
		}
	};

	extractTextNodes(children);

	useEffect(() => {
		indexRef.current = -1;
		const interval = setInterval(() => {
			indexRef.current += 1;
			if (indexRef.current >= allTextNodes.length) {
				clearInterval(interval);
				setTypingCnt((prev: any) => prev + 1);
				return;
			}

			setDisplayedNodes((prev) => [...prev, allTextNodes[indexRef.current]]);
		}, speed);

		return () => clearInterval(interval);
	}, [speed]);

	const renderNode = (
		node: React.ReactNode,
		currentIndexRef: { index: number }
	): React.ReactNode => {
		if (typeof node === "string") {
			return node
				.split("")
				.map((char) =>
					currentIndexRef.index < displayedNodes.length
						? displayedNodes[currentIndexRef.index++]
						: ""
				);
		} else if (React.isValidElement(node) && node.props.children) {
			return React.cloneElement(node, {
				children:
					React.Children.map(node.props.children, (child) =>
						renderNode(child, currentIndexRef)
					) ?? node.props.children,
			} as React.Attributes & { children?: React.ReactNode });
		}
		return node;
	};

	return <>{renderNode(children, { index: 0 })}</>;
};
